// DiscoverFlixRow.js
import DiscoverFlixProvider from '../container/DiscoverFlixProvider.js';
import DiscoverFlixRow from '../component/DiscoverFlixRow.jsx';

export default DiscoverFlixProvider(DiscoverFlixRow);
